import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16" data-testid="contact-page">
      <div className="text-xs uppercase tracking-[0.2em] text-blue-600 font-bold">Contact</div>
      <h1 className="font-display text-5xl font-black tracking-tight text-slate-900 mb-2">Talk to a human.</h1>
      <p className="text-slate-600 max-w-xl">
        Office hours: Mon – Sat, 10:00 – 19:00 IST. Walk-ins welcome by appointment.
      </p>
      <div className="grid md:grid-cols-3 gap-6 mt-10">
        <div className="border border-slate-200 rounded p-6 bg-white">
          <MapPin className="w-5 h-5 text-blue-600 mb-3"/>
          <div className="font-bold mb-1">Office</div>
          <div className="text-sm text-slate-600">625, Suraksha Smart City, Madhuban Township, Rajavali, Golani Naka, Vasai East, Vasai-Virar, Maharashtra 401208, India</div>
        </div>
        <div className="border border-slate-200 rounded p-6 bg-white">
          <Phone className="w-5 h-5 text-blue-600 mb-3"/>
          <div className="font-bold mb-1">Phone</div>
          <a className="text-sm text-blue-700 hover:underline" href="tel:+918652422980" data-testid="contact-phone">+91 86524 22980</a>
        </div>
        <div className="border border-slate-200 rounded p-6 bg-white">
          <Mail className="w-5 h-5 text-blue-600 mb-3"/>
          <div className="font-bold mb-1">Email</div>
          <a className="text-sm text-blue-700 hover:underline" href="mailto:aloka.co.in@gmail.com" data-testid="contact-email">aloka.co.in@gmail.com</a>
        </div>
      </div>
    </div>
  );
}
